let MOBILE = 1100;
export interface ScreenSizes {
    mediaXXS: number
    mediaXS: number
    mediaMS: number
    mediaSS: number
    mediaS: number
    mediaSM: number
    mediaM: number
    mediaMM: number
    mediaL: number
    mediaCL: number
    mediaXL: number
    mediaXCL: number
    mediaXXL: number
    mediaLX: number
    mediaLXX: number
}

export const screenSizes: ScreenSizes = {
    mediaXXS: 360,
    mediaXS: 380,
    mediaMS: 425,
    mediaSS: 480,
    mediaS: 640,
    mediaSM: 700,
    mediaM: 800,
    mediaMM: 900,
    mediaL: 1024,
    mediaCL: 1180,
    mediaXL: 1280,
    mediaXCL: 1350,
    mediaXXL: 1480,
    mediaLX: 1800,
    mediaLXX: 2000,
}

export { MOBILE };
